import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateParser, TranslateService } from '@ngx-translate/core';

export class AppMatPaginatorIntl extends MatPaginatorIntl {

  private rangeLabelIntl: string;

  constructor(private translateService: TranslateService, private translateParser: TranslateParser) {
    super();
    this.getTranslations();
    this.translateService.onLangChange.subscribe(() => this.getTranslations());
    this.translateService.onTranslationChange.subscribe(() => this.getTranslations());
  }

  getTranslations() {
    const translation = this.translateService.instant([
      'PAGINATOR.ITEMS_PER_PAGE',
      'PAGINATOR.NEXT_PAGE',
      'PAGINATOR.PREVIOUS_PAGE',
      'PAGINATOR.RANGE'
    ]);

    this.itemsPerPageLabel = translation['PAGINATOR.ITEMS_PER_PAGE'];
    this.nextPageLabel = translation['PAGINATOR.NEXT_PAGE'];
    this.previousPageLabel = translation['PAGINATOR.PREVIOUS_PAGE'];
    this.rangeLabelIntl = translation['PAGINATOR.RANGE'];
    this.changes.next(void 0);
  }

  getRangeLabel = (page, pageSize, length) => {
    length = Math.max(length, 0);
    const startIndex = length > 0 ? page + 1 : 0;
    let endIndex = Math.ceil(length / pageSize);
    if(endIndex == 0 && length > 0){
      endIndex = endIndex++;
    }
    return this.translateParser.interpolate(this.rangeLabelIntl, { startIndex, endIndex, length });
  };

}